import { render, staticRenderFns } from "./ProtocolSessionEn.vue?vue&type=template&id=0d4bf6d2&"
import script from "./ProtocolSessionEn.vue?vue&type=script&lang=js&"
export * from "./ProtocolSessionEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports